import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dec5ce42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no_rem_name co-737373 no_rem_mr-24 no_rem_lh-44" }
const _hoisted_2 = { class: "flex-row-wrap flex-1" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "name co-737373 mr-14 lh-44" }
const _hoisted_5 = { class: "classify-area" }
const _hoisted_6 = ["onClick"]

import {
		ref,
		withDefaults,
		getCurrentInstance
	} from 'vue';
	interface PropsType {
		name ? : any,
			list ? : any,
			show_line ? : any
	}

	// 子->父 emit
	interface EmitType {
		(e: "tagClick", params: string)
	}

	// 父->子
	
export default /*#__PURE__*/_defineComponent({
  __name: 'ClassifyPart',
  props: {
    name: { default: "" },
    list: { default: [] },
    show_line: { default: false }
  },
  emits: ["tagClick"],
  setup(__props: any, { emit }: { emit: ({
		(e: "tagClick", params: string)
	}), expose: any, slots: any, attrs: any }) {

const prop = __props as { name: any, list: any, show_line: any };

	const {
		proxy
	} = getCurrentInstance();

	// 父->子 prop值类型
	

	// 子->父
	
	const activeIndex = ref(0);

	// 分类选中
	const tagClick = (index: any) => {
		activeIndex.value = index;
		emit("tagClick", index);
	}

return (_ctx: any,_cache: any) => {
  return (!_unref(proxy).$store.state.is_phone)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex-row no_rem_classify", {'no_rem_show_line': prop.show_line}])
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(prop.name), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.list, (v, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["no_rem_lh-44 flex-row-center-center no_rem_mr-30 no_rem_classify_item pointer", {'font-blod': activeIndex.value == i,'co-862331': activeIndex.value == i, 'co-161A1D': activeIndex.value != i}]),
              onClick: ($event: any) => (tagClick(i))
            }, _toDisplayString(v.name), 11, _hoisted_3))
          }), 128))
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex-row classify", {'show_line': prop.show_line}])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(prop.name), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.list, (v, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["lh-41 mr-14 classify_item", {'font-blod': activeIndex.value == i,'co-862331': activeIndex.value == i, 'co-161A1D': activeIndex.value != i}]),
              onClick: ($event: any) => (tagClick(i))
            }, _toDisplayString(v.name), 11, _hoisted_6))
          }), 128))
        ])
      ], 2))
}
}

})